import { treeAspectMinorTabgroup, wikiTab, isRootDomainConfig, isDomainRecord } from './utils';
export const sys = {
    ...treeAspectMinorTabgroup,
    tabGroup: 'sys',
    acl: 'g:debug',
    cfg: isRootDomainConfig,
    enabled: isDomainRecord,
    tabs: {
        overview: {
            default: true,
            tabGroupDefault: true,
            parts: [
                {
                    type: 'SysOverview',
                    filters: [
                        'getDashSysinfo',
                        'getDashStorage',
                        'getDashDomainInfo'
                    ]
                }
            ]
        },
        cfg: {
            parts: [
                {
                    type: 'InstanceCfgEditor',
                    filters: [
                        'getInstanceConfigs'
                    ]
                }
            ]
        },
        logs: {
            parts: [
                {
                    type: 'SysLogs',
                    filters: [
                        'getLoggingInfo'
                    ]
                }
            ]
        },
        cache: {
            minorTabGroup: 'caches',
            parts: [
                {
                    type: 'SysTool',
                    name: 'CacheInfo'
                }
            ]
        },
        apicache: {
            minorTabGroup: 'caches',
            parts: [
                {
                    type: 'SysTool',
                    name: 'ApiCacheInfo'
                }
            ],
            label: 'Api'
        },
        interpreter: {
            parts: [
                {
                    type: 'SimpleInterpreter',
                    style: {
                        overflow: 'hidden'
                    }
                }
            ]
        },
        sessions: {
            parts: [
                'SessionsViewer'
            ]
        },
        status: {
            minorTabGroup: 'system',
            parts: [
                {
                    type: 'SysTool',
                    name: 'StartstopInfo',
                    filters: [
                        'getStartStopInfo'
                    ]
                }
            ]
        },
        startup: {
            minorTabGroup: 'system',
            parts: [
                {
                    type: 'SysTool',
                    name: 'StartupAnalyzer',
                    filters: [
                        'getStartupInfo'
                    ]
                }
            ]
        },
        nginx: {
            minorTabGroup: 'system',
            parts: [
                {
                    type: 'SysTool',
                    name: 'NginxInfo'
                }
            ]
        },
        source: {
            minorTabGroup: 'system',
            parts: [
                {
                    type: 'SysTool',
                    name: 'SourceStats',
                    filters: [
                        'getSourceStats'
                    ]
                }
            ]
        },
        views: {
            minorTabGroup: 'system',
            parts: [
                'InspectViews'
            ]
        },
        bundle: {
            minorTabGroup: 'system',
            parts: [
                {
                    type: 'SysTool',
                    name: 'WebpackBundle',
                    style: {
                        display: 'flex',
                        overflow: 'hidden'
                    }
                }
            ]
        },
        nodes: {
            minorTabGroup: 'system',
            parts: [
                {
                    type: 'SysTool',
                    name: 'ProcessNodes'
                }
            ]
        },
        poolexhaustions: {
            minorTabGroup: 'system',
            parts: [
                {
                    type: 'SysTool',
                    name: 'PoolExhaustions'
                }
            ]
        },
        imgprofiles: {
            minorTabGroup: 'system',
            parts: [
                {
                    type: 'SysTool',
                    name: 'ImageProfiles'
                }
            ]
        },
        threads: {
            minorTabGroup: 'system',
            parts: [
                {
                    type: 'SysTool',
                    name: 'SysThreads'
                }
            ]
        },
        fds: {
            minorTabGroup: 'system',
            parts: [
                {
                    type: 'SysTool',
                    name: 'SysFds'
                }
            ]
        },
        requests: {
            minorTabGroup: 'system',
            parts: [
                {
                    type: 'SysTool',
                    name: 'SysRequests'
                }
            ]
        },
        spabuild: {
            minorTabGroup: 'system',
            parts: [
                {
                    type: 'SysTool',
                    name: 'SpaBundleInfo'
                }
            ]
        },
        events: {
            minorTabGroup: 'system',
            parts: [
                {
                    type: 'SysTool',
                    name: 'ServerEvents'
                }
            ]
        },
        pmove: {
            minorTabGroup: 'system',
            parts: [
                {
                    type: 'SysTool',
                    name: 'SysParentMove'
                }
            ]
        }
    }
};
